module.exports = __webpack_public_path__ + "static/media/azo-fra-train.53619095.svg";